module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step4-de60a04092d13d75f558592b38be10e3.jpg";